/** Minimum gap between automatic update checks triggered by the app returning to the foreground. */
export const UPDATE_CHECK_MIN_INTERVAL_MS = 30 * 60 * 1000;

/** Longest the splash screen is held at launch waiting for an update check/download. */
export const STARTUP_UPDATE_TIMEOUT_MS = 4000;

export const shouldCheckForUpdate = (
  lastCheckedAt: number | null,
  now: number,
  minIntervalMs: number = UPDATE_CHECK_MIN_INTERVAL_MS,
): boolean => lastCheckedAt === null || now - lastCheckedAt >= minIntervalMs;

const CONNECTIVITY_ERROR_PATTERN =
  /network|internet|offline|timed? ?out|unknownhost|unable to resolve host|could not connect|connection (?:was )?(?:lost|failed|refused|reset)/i;

/** Update checks routinely fail with no signal; those are not worth an alert. */
export const isConnectivityError = (error: unknown): boolean =>
  CONNECTIVITY_ERROR_PATTERN.test(
    error instanceof Error ? `${error.name} ${error.message}` : String(error),
  );
